import { RequiredError } from "../error/RequiredError.js";
import { ValueError } from "../error/ValueError.js";
import { isIterable } from "./iterate.js";
import { deleteProps, isPlainObject, omitProps, pickProps, setProp, setProps, withProp, withProps } from "./object.js";
/** Is an unknown value a dictionary object? */
export function isDictionary(value) {
    return isPlainObject(value);
}
/** Assert that an unknown value is a dictionary object */
export function assertDictionary(value) {
    if (!isDictionary(value))
        throw new ValueError("Must be dictionary", value);
}
/** turn a possible dictionary into a dictionary. */
export function getDictionary(obj) {
    return isIterable(obj) ? Object.fromEntries(obj) : obj;
}
export function getDictionaryItems(obj) {
    return isIterable(obj) ? obj : Object.entries(obj);
}
/** Is an unknown value the key for an own prop of a dictionary. */
export function isDictionaryItem(obj, key) {
    return typeof key === "string" && Object.hasOwn(obj, key);
}
/** Assert that an unknown value is the key for an own prop of a dictionary. */
export function assertDictionaryItem(obj, key) {
    if (!isDictionaryItem(obj, key))
        throw new ValueError("Must be dictionary item", key);
}
/** Get an item in a map or throw an error if it doesn't exist. */
export function getDictionaryItem(obj, key) {
    if (!Object.hasOwn(obj, key))
        throw new RequiredError(`Dictionary item is required`);
    return obj[key];
}
/** Get an item in a map or `undefined` if it doesn't exist. */
export function getOptionalDictionaryItem(obj, key) {
    return obj[key];
}
/** Set a prop on a dictionary object (immutably) and return a new object including that prop. */
export const withDictionaryItem = withProp;
/** Set several props on a dictionary object (immutably) and return a new object including those props. */
export const withDictionaryItems = withProps;
/** Remove several key/value entries from a dictionary object (immutably) and return a new object without those props. */
export const omitDictionaryItems = omitProps;
/** Pick several props from a dictionary object and return a new object with only thos props. */
export const pickDictionaryItems = pickProps;
/** Set a single named prop on a dictionary object (by reference) and return its value. */
export const setDictionaryItem = setProp;
/** Set several named props on a dictionary object (by reference). */
export const setDictionaryItems = setProps;
/** Remove several key/value entries from a dictionary object (by reference). */
export const deleteDictionaryItems = deleteProps;
